import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import { loginState, uiState } from "@/states.ts";
import { deleteAccount } from "@/api/auth_api.ts";

const DeleteAccountDialog: React.FC = (props) => {
	const [verify, setVerify] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleDelete = () => {
		setError(null);
		if (verify.toLowerCase() != "delete my account") {
			setError("Incorrect verification.");
			return;
		}

		deleteAccount().then((r) => {
			loginState.token = undefined;
			localStorage.clear();
			window.location.href = import.meta.env.VITE_LANDING_URL;
		});
	};

	const handleClose = () => {
		uiState.deleteAccount = false;
	};

	return (
		<>
			<Dialog.Root open={true}>
				<Dialog.Portal>
					<Dialog.Overlay className="DialogOverlay" />
					<Dialog.Content className="DialogContent">
						<div className={"p-4 flex flex-col space-y-2"}>
							<Dialog.Title className="DialogTitle">
								Delete Account
							</Dialog.Title>
							<div>
								Are you sure you want to delete your
								account?
								<br /> Type{" "}
								<span className={"text-primary"}>
									Delete my Account
								</span>{" "}
								to delete.
							</div>
							<div className={"flex items-center gap-4"}>
								<Input
									placeholder={
										"Delete my account"
									}
									value={verify}
									className={
										"bg-secondary/30"
									}
									onChange={(e) =>
										setVerify(
											e.target
												.value,
										)
									}
								/>
							</div>
							{error && (
								<div className={"text-red-500"}>
									{error}
								</div>
							)}
							<div
								className={
									"flex justify-between items-center pt-4"
								}
							>
								<div>
									<Button
										variant={
											"destructive"
										}
										onClick={
											handleDelete
										}
									>
										Delete
									</Button>
								</div>
								<div className="flex gap-4">
									<Button
										variant={"ghost"}
										onClick={
											handleClose
										}
									>
										Cancel
									</Button>
								</div>
							</div>
						</div>
					</Dialog.Content>
				</Dialog.Portal>
			</Dialog.Root>
		</>
	);
};

export { DeleteAccountDialog };
